module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    directives: [{
      name: "lang",
      rawName: "v-lang.copyright",
      modifiers: {
        "copyright": true
      }
    }]
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "rs",
    attrs: {
      "href": "https://www.facebook.com/pages/super-visionfr/545834958791592",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "img/facebook.png",
      "alt": "fb",
      "border": "0"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7aa737af","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/Footer.vue
// module id = 56
// module chunks = 0